import * as React from 'react';

const SvgZinc = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="18" height="18" rx="6" fill="black" />

    <path
      d="M15.0772 12.4589V5.54049C15.0772 5.53023 15.0715 5.52109 15.0628 5.51596L9.01479 2.05646C9.00613 2.05133 8.99455 2.05133 8.98588 2.05646L2.93729 5.51596C2.92863 5.52109 2.92285 5.53023 2.92285 5.54049V12.4595C2.92285 12.4698 2.92863 12.4789 2.93729 12.484L8.98532 15.9435C8.99398 15.9487 9.00556 15.9487 9.01423 15.9435L15.0622 12.484C15.0709 12.4789 15.0767 12.4698 15.0767 12.4595L15.0772 12.4589Z"
      fill="url(#paint0_linear_3131_182)"
    />

    <path
      d="M8.10727 4.95605L5.6958 6.34454V7.31126L7.63245 6.19444L7.64229 6.20414L6.1515 8.90577V9.92843L9.45597 8.03321L9.4652 8.04291L6.87293 11.6827V12.8367L13.71 8.91547L12.6749 8.32422L8.83849 10.5476L8.82927 10.5385L11.2598 6.98254L10.3864 6.4758L7.40491 8.19296L7.39507 8.18326L8.95286 5.44401L8.10727 4.95605Z"
      fill="black"
    />

    <defs>
      <linearGradient
        id="paint0_linear_3131_182"
        x1="9.00034"
        y1="2.05247"
        x2="9.00034"
        y2="15.9469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFCE" />
        <stop offset="0.4" stopColor="#02FACA" />
        <stop offset="0.83" stopColor="#09EDC2" />
        <stop offset="1" stopColor="#0EE6BD" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgZinc;
